import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { clearPinData } from 'lib/actions';
import { CARDS } from 'constants/shared/routes';
import PinOptions from '../presentational/PinOptions';
import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';
import DataCheck from 'components/shared/generic/dataCheck/presentational/DataCheck';
import Error from 'components/shared/generic/errorMessage/presentational/Error';

interface LocationState {
    authCVC?: string;
    pin?: string | number;
}

const PinOptionsContainer: FC = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const state = location.state as LocationState;

    useEffect(() => {
        if (!state || !state.authCVC) {
            navigate(CARDS);
        }

        return () => {
            dispatch(clearPinData());
        };
    }, [dispatch, navigate, state]);

    const isLoading = !state || !state.authCVC;

    return (
        <PageContainer className="pin-options-container">
            <DataCheck
                isLoading={isLoading}
                noDataMessage="Your pin can't be found"
                data={state}
            >
                {state?.pin ? (
                    <PinOptions pin={`${state.pin}`} />
                ) : (
                    <Error
                        message="Could not find pin associated to this card, please contact customer support"
                        backRoute={CARDS}
                    />
                )}
            </DataCheck>
        </PageContainer>
    );
};

export default PinOptionsContainer;
